import BaseService from "../base.service";

const VUE_APP_API_URL = process.env.VUE_APP_API_URL;

class PromotionsService extends BaseService {
    getPromos() {
        return this.get(`${VUE_APP_API_URL}/api/promotions`).then(({ data }) => data)
    }

    checkCustomerPromos() {
        return this.get(`${VUE_APP_API_URL}/api/promotion-status`).then(({ data }) => data)
    }
}
export default new PromotionsService()